import { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import handleFileSelection from '../helpers/FileSelection';

const useFileSelection = (files, selectFile, unselectFile) => {
  const [lastSelectedIndex, setLastSelectedIndex] = useState(null);

  const handleFileSelect = useCallback((fileUuid, isSelected) => {
    const { event } = window;
    const newLastSelectedIndex = handleFileSelection(
      files,
      fileUuid,
      isSelected,
      lastSelectedIndex,
      selectFile,
      unselectFile,
      event,
    );

    setLastSelectedIndex(newLastSelectedIndex);
  }, [files, lastSelectedIndex, selectFile, unselectFile]);

  return {
    handleFileSelect,
  };
};

useFileSelection.propTypes = {
  files: PropTypes.array.isRequired,
  selectFile: PropTypes.func.isRequired,
  unselectFile: PropTypes.func.isRequired,
};

export default useFileSelection;
